<template>
  <div class="remark-list flex fww aic">
    <div class="remark-item flex-col jcc aic" v-for="(item, i) in remarkList" :key="i">
      <div class="remark-img-ico" :class="item.ico"></div>
      <div class="remark-title">{{item.title}}</div>
      <div class="remark-subtitle">{{item.subtitle}}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MineRemark',
    data() {
      return {
        remarkList: [
          {ico: 'r1', title: '海量课程', subtitle: '畅享所有VIP课程'},
          {ico: 'r2', title: '教材同步', subtitle: '多版本教材同步学'},
          {ico: 'r3', title: '全科补课', subtitle: '各学段学科齐全'},
          {ico: 'r4', title: '高端教学资源', subtitle: '北京黄冈教师授课'},
          {ico: 'r5', title: '高效提分', subtitle: '同步重难点全掌握'},
          {ico: 'r6', title: '精品课会员专属价', subtitle: '拓展学习更轻松'},
          {ico: 'r7', title: '无限回放', subtitle: '录播课随时看任意学'},
          {ico: 'r8', title: '多终端权益', subtitle: '手机/平板/电视权益共享'},
        ],
      };
    },
  }
</script>

<style scoped lang="less">
  .remark-list {
    margin: -10px 0 0 -24px;
    line-height: 1;
    .remark-item {
      margin: 10px 0 0 24px;
      width: 194px;
      height: 144px;
    }
    .remark-img-ico {
      width: 58px;
      height: 58px;
      &.r1 {
        background: url(../../assets/images/user/r1.png) no-repeat top left / 100% 100%;
      }
      &.r2 {
        background: url(../../assets/images/user/r2.png) no-repeat top left / 100% 100%;
      }
      &.r3 {
        background: url(../../assets/images/user/r3.png) no-repeat top left / 100% 100%;
      }
      &.r4 {
        background: url(../../assets/images/user/r4.png) no-repeat top left / 100% 100%;
      }
      &.r5 {
        background: url(../../assets/images/user/r5.png) no-repeat top left / 100% 100%;
      }
      &.r6 {
        background: url(../../assets/images/user/r6.png) no-repeat top left / 100% 100%;
      }
      &.r7 {
        background: url(../../assets/images/user/r7.png) no-repeat top left / 100% 100%;
      }
      &.r8 {
        background: url(../../assets/images/user/r8.png) no-repeat top left / 100% 100%;
      }
    }
    .remark-title {
      margin: 12px 0;
      font-size: 16px;
      color: #333f4e;
    }
    .remark-subtitle {
      font-size: 14px;
      color: #999fa6;
    }
  }
</style>